export function loadScriptContent(scriptContent, flg_carregou_script_revenda) {
  if (!flg_carregou_script_revenda) {
    if (scriptContent) {
      try {
        console.log('script do usuario');
        // Verifica se o conteúdo tem um <noscript> e lida com ele
        if (scriptContent.includes('<noscript>')) {
          // Extraímos o conteúdo <noscript> corretamente
          const noscriptContent = scriptContent.match(/<noscript>(.*?)<\/noscript>/s)?.[1];
          if (noscriptContent) {
            const noscriptElement = document.createElement('noscript');
            noscriptElement.innerHTML = noscriptContent;
            document.body.appendChild(noscriptElement);
          }
        }

        // Remove as tags <script>  do conteúdo
        const sanitizedScriptContent = scriptContent
          .replace(/<noscript>.*?<\/noscript>/gs, '')  // Remove <noscript> e seu conteúdo
          .replace(/<script[^>]*>|<\/script>/g, '')   // Remove as tags <script>
          .trim();
        //console.log('sanitizedScriptContent', sanitizedScriptContent);
        // Cria o script com segurança
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.textContent = sanitizedScriptContent; // Insere o conteúdo limpo

        //console.log('Conteúdo do script:', sanitizedScriptContent); // Aqui mostramos o conteúdo do script sem as tags
        document.head.appendChild(scriptElement);

        //console.log('Script do revendedor e <noscript> carregados.');
        return true;
      } catch (error) {
        console.error('Erro ao carregar o script do revendedor:', error);
      }
    } else {
      // Carrega o script padrão
      const defaultScript = document.createElement('script');
      defaultScript.async = true;
      defaultScript.defer = true;
      defaultScript.src = 'https://www.chatinteligente.com.br/js/analytics.js?v=1.0.0';
      document.head.appendChild(defaultScript);
      console.log('Script padrão carregado.');
      return true;
    }
  }
  return false; // Retorna false se o script não precisar ser carregado
}

export function carregaAnalyticsCi() {
  // Carrega o script padrão
  const defaultScript = document.createElement('script');
  defaultScript.async = true;
  defaultScript.defer = true;
  defaultScript.src = 'https://www.chatinteligente.com.br/js/analytics.js?v=1.0.0';
  document.head.appendChild(defaultScript);
  console.log('Script padrão carregado.');
}
